
const notification = {
    state: {
        type: null,
        message: null
    },
    mutations: {
        success(state, message) {
            state.type = 'success';
            state.message = message;
        },
        error(state, message) {
            state.type = 'danger';
            state.message = message;
        },
        clear(state) {
            state.type = null;
            state.message = null;
        }
    },
    actions: {
        notificationSuccess({ commit }, message) {
            commit('success', message);
        },
        notificationError({ commit }, message) {
            commit('error', message);
        },
        notificationClear({ commit }) {
            commit('clear');
        }
    }
};


export default notification;
